import { oneLine } from 'common-tags/es';

const data = {
    type: 'contentpage',
    path: '/measures/home',
    meta: {
        title: 'A place to call home | Child Poverty',
    },
    title: 'A place to call home',
    intro: oneLine`High housing costs contribute to many whānau living in poverty. <b>More than 30%</b> of the 
        lowest income households with tamariki spend more than half of their income on housing costs.`,
    image: {
        filename: 'Home.png',
        alt: '',
    },
    content: [
        oneLine`<p>The 2018 Census found that around 25% (just under a quarter of a million) of tamariki lived in 
            houses that were sometimes damp and 18% (170,000 tamariki) in houses that sometimes had mould larger than 
            the size of an A4 sheet of paper.</p>`,
        oneLine`<p>To fix this disparity, the Government needs to continue increasing the supply of social housing and 
            work with community-based housing providers to create a broader range of ownership and renting options.</p>`,
    ],
};

export default data;
